<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
  <ng-container>
      <ion-icon [src]="'Icons.promotion-modal' | translate" 
      class="img-broken-heart animated fadeIn fast"></ion-icon
    ></ng-container>

  <ion-card mode="ios" color="white-grad" class="card-content">
    <ion-item 
      mode="md" 
      lines="none" 
      color="transparent" 
      class="ion-text-center item-text"
    >
      <ion-label mode="md" class="mpe-font-weight-700 title" [innerHtml]="titleText">
      </ion-label>
    </ion-item>

    <ion-item 
      mode="md" 
      lines="none" 
      color="transparent" 
      class="ion-text-center item-text"
    >
      <ion-label
        mode="md" 
        class="mpe-font-weight-400 subtitle" [innerHtml]="infoText"
      >
      </ion-label>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button 
        size="default" 
        mode="md" 
        color="gradient-blue" 
        class="button-enderstood" 
        (click)="onClose(1)"
        >
        <ion-label 
          mode="md" 
          color="white" 
          class="mpe-font-weight-900 go-to-promotion" 
          [innerHtml]="buttonText"
          >
        </ion-label>
      </ion-button>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button 
        size="default" 
        mode="md" 
        fill="clear" 
        color="grayDemon" 
        class="mpe-button-link-simple button-simple"
        (click)="onClose(2)"
        >
        <ion-label mode="md" color="status-icon-enable" class="later">
          {{ 'Buttons.view-later' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-card>
</ion-list>